import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { CompetitiveIntelligencePageBg } from "@/components/site/CompetitiveIntelligencePageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-analysis/competitive-intelligence")({
  head: () => ({
    meta: [
      { title: "Анализ на конкуренцията и медийни анализи | Perceptica" },
      {
        name: "description",
        content:
          "Perceptica сравнява вашия бранд с основните ви конкуренти чрез медиен мониторинг и анализ на тоналност, наративи, позиции и възможности за по-силно пазарно присъствие.",
      },
      { property: "og:title", content: "Анализ на конкуренцията и медийни анализи | Perceptica" },
      {
        property: "og:description",
        content:
          "Perceptica сравнява вашия бранд с основните ви конкуренти чрез медиен мониторинг и анализ на тоналност, наративи, позиции и възможности за по-силно пазарно присъствие.",
      },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Анализ на конкуренцията и медийни анализи | Perceptica" },
      { name: "twitter:description", content: "Perceptica сравнява вашия бранд с основните ви конкуренти чрез медиен мониторинг и анализ на тоналност, наративи, позиции и възможности за по-силно пазарно присъствие." },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis/competitive-intelligence" },
      ...ogImageMeta("bg", "/media-analysis/competitive-intelligence"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis/competitive-intelligence", service: { name: "Конкурентно разузнаване", description: "Конкурентно разузнаване от Perceptica за Югоизточна Европа.", serviceType: "Конкурентно разузнаване" } }),
  }),
  component: CompetitiveIntelligencePageBg,
});
